import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/cargoOwnerDictionary";

const index = ({ preparedFilter, counterpartyId, ...params }: OdataFilters & { counterpartyId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter }).substr(1);
    return request(
        `${resource}/getContracts?counterpartyId=${counterpartyId}&${query}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};

const getListExcel = ({ preparedFilter, counterpartyId, ...params }: OdataFilters & { counterpartyId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter }).substr(1);
    return request(
        `${resource}/getContractsExcel?counterpartyId=${counterpartyId}&${query}`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Договоры контрагентов.xlsx"));
};

const list = ({ counterpartyId, legalPersonId, ...params }: { counterpartyId: number; legalPersonId: number }) => {
    const query = containsQuery(params, {
        filter: legalPersonId ? { or: [{ legalPersonId }, { legalPersonId: null }] } : { legalPersonId: null },
    }).substr(1);
    return request(`${resource}/getContractsForSelect?counterpartyId=${counterpartyId}&${query}`, {
        method: "GET",
    });
};

const getContractsForFilter = (number: number) => {
    const query = queryCollection({}, { filter: { number: { contains: number } } });
    return request(`${resource}/getContractsForFilter${query}`, { method: "GET" });
};

const apply = (params: {}) => alertRequest(`${resource}/applyContract`, body(params));

const getItem = (params: { counterpartyId: number; id: number }) =>
    request(`${resource}/getContract?counterpartyId=${params.counterpartyId}&contractId=${params.id}`, {
        method: "GET",
    });

const delItem = (params: {}) => alertRequest(`${resource}/deleteContract`, body(params));

export { index, apply, getItem, delItem, list, getContractsForFilter, getListExcel };
